<template>
  <div>
    <div class="fixed top-0 left-0 right-0 bg-gray-100 z-40 shadow flex flex-col justify-center h-24">
      <div class="flex justify-center md:justify-between items-center w-full mx-auto lg:px-4">
        <div class="flex items-center">
          <img src="/images/Cardstock_Logo.png" class="w-32 md:w-48">
        </div>
        <div class="hidden md:block">
          <a class="underline pr-4 cursor-pointer text-yes-light-grey hover:text-yes-royal-blue" href="/login" tabindex="0">
            Sign in</a>
          <a class="text-white py-2 px-4 rounded shadow-md cursor-pointer bg-cardstock-green-500 hover:bg-yes-green-500 outline-none font-bold" tabindex="0" href="mailto:lanny.bose@cardstockforteachers.com">
            Start your trial now</a>
        </div>
      </div>
    </div>

    <div class="max-w-screen-md h-screen text-2xl md:text-5xl flex flex-col justify-center pb-16 px-8 md:px-0 -mb-16 pt-24 md:pt-0 w-full mx-auto lg:px-4">
      <div class="mb-6 md:mb-24 font-medium text-center md:text-left">
        <span class="text-cardstock-red-500 font-bold">Cardstock</span> helps teachers make parent communication a habit.
      </div>
      <div class="text-center mb-6 md:hidden">
        <router-link :to="{name: 'login'}" class="md:hidden text-white py-2 px-4 rounded shadow cursor-pointer bg-cardstock-green-500 outline-none font-bold inline-block text-base">
          Log In
        </router-link>
      </div>
      <div class="hidden md:flex justify-between text-base leading-normal">
        <div class="flex flex-col justify-center rounded bg-cardstock-yellow-500 p-8 w-1/2">
          <div class="uppercase font-black mb-2 underline mb-4">Key Points</div>
          <ol class="list-reset">
            <li class="mb-2">It's an app</li>
            <li class="mb-2">You get a phone number</li>
            <li class="mb-2">You can text and call parents</li>
            <li class="mb-2">Parents can text and call back</li>
            <li class="mb-2">For you as a teacher, or for principals and their school teams</li>
          </ol>
        </div>
        <div class="flex flex-col p-8 text-lg w-1/2">
          <div class="mb-4">
            Cardstock teachers have communicated home over 2,000,000 times since 2015.
          </div>
          <div class="mb-4">
            Join them!
          </div>
          <div class="text-center">
            <a href="mailto:lanny.bose@cardstockforteachers.com" class="text-white py-2 px-4 rounded shadow-md cursor-pointer bg-cardstock-green-500 outline-none font-bold inline-block" tabindex="0">
              Start your trial</a>
          </div>
        </div>
      </div>
    </div>


    <div class="max-w-screen-md min-h-half-screen flex flex-col text-xl md:text-5xl pb-16 px-8 leading-normal w-full mx-auto lg:px-4">
      <div class="mb-8 md:mb-16">
        Make parent communication a habit, you say?
      </div>
      <div class="mb-8 md:mb-16">
        If parent communication is going to be a habit for us, it really shouldn't feel like a chore...
      </div>
      <div class="w-full text-right">
        ...but too often, it does.
      </div>
    </div>

    <div class="min-h-3/4-screen flex flex-col items-start backpack-disaster py-16 px-8 leading-normal justify-center text-lg md:text-3xl ">
      <div class="max-w-screen-lg flex flex-col w-full mx-auto lg:px-4">
        <div class="bg-disaster-grey mb-8 p-8">
          Maybe, it's that between 📄 making copies and 🥪 scarfing lunch and 🚌 bus duty and "<em>oh hey, you remember that</em> 📆 <em>literacy team meeting</em>" we just don't have the time.
        </div>
        <div class="bg-disaster-grey mb-8 p-8">
          Or maybe it’s that we speak a different language than some of our families and we're a little unsure 😬 about our own ability to engage.
        </div>
        <div class="bg-disaster-grey mb-8 p-8">
          And sending notes home in 🎒 backpacks that look like 🌪 disaster areas seems like a losing proposition...
        </div>
        <div class="bg-disaster-grey mb-8 p-8">
          Communication falls down the list of priorities. 📉
        </div>
      </div>
    </div>


    <div class="bg-black py-16 px-8">
      <div class="max-w-screen-md text-xl leading-loose min-h-half-screen flex flex-col justify-center items-center text-white w-full mx-auto lg:px-4">
        <div class="font-regular text-5xl">
          🤦‍♀️🤦‍
        </div>
        <div class="font-italic text-xl md:text-2xl mb-8">
          Don't worry. We’ve all been that teacher whose very first call home was bad news in November… That conversation didn't go well.
        </div>
        <div class="font-italic text-xl md:text-2xl mb-8">
          And of course there was the family we saw at Meet the Teacher Night and never really talked to again because their student sort-of flew under the radar.
        </div>
        <div class="font-italic text-xl md:text-2xl mb-8">
          And sometimes we've over-relied on terse, paint-by-numbers
          <span class="font-mono text-sm rounded has-shown-improvement bg-cardstock-green-500 inline-block py-1 px-2 font-normal whitespace-nowrap">A1. Needs improvement</span> feedback...
        </div>
        <div class="font-italic text-xl md:text-2xl">
          None of that worked. Now, let's get it right.
        </div>
      </div>
    </div>

    <div class="max-w-screen-md min-h-3/4-screen flex flex-col justify-center leading-normal py-16 px-8 text-lg md:text-3xl w-full mx-auto lg:px-4">

      <div class="mb-8">
        Our vision for <span class="text-cardstock-red-500">Cardstock</span> is that all families deserve to be engaged with regularly. Deserve to be viewed as an asset and a partner and a part of the team. Deserve to hear how <span class="text-cardstock-blue-500 underline">great</span> their kiddo really is.
      </div>

      <div class="">
        And everyday, <span class="text-cardstock-red-500">Cardstock</span> teachers send home wins.
      </div>

    </div>

    <div class="big-wins min-h-3/4-screen flex flex-col justify-center py-16 px-8">
      <div class="max-w-screen-xl leading-none tracking-tight uppercase font-black w-full mx-auto lg:px-4">
        <div class="text-4xl sm:text-5xl md:text-6xl lg:text-9xl text-white">
          The big triumphant just-got-into-college wins.
        </div>
      </div>
    </div>

    <div class="bg-orange-600 py-16 px-8">
      <div class="min-h-3/4-screen flex flex-col justify-center w-full mx-auto lg:px-4">
        <div class="text-lg text-left md:text-center text-white leading-normal">
          And the little, <span class="font-black uppercase">triumphant</span>, you-should-see-how-kind-she-is-to-her-classmates wins.
        </div>
      </div>
    </div>

    <div class="min-h-3/4-screen pt-12 flex flex-col justify-center leading-normal text-lg md:text-3xl py-16 px-8 text-left md:text-center">
      <div class="max-w-screen-md w-full mx-auto lg:px-4">
        <div class="mb-8 md:mb-16">
          <span class="text-cardstock-red-500 font-medium">Cardstock</span> makes it easy to send home those wins and communicate with <span class="text-cardstock-blue-500 underline">all</span> parents. Make calls. Send one-off text messages. Blast the sixth grade parents a reminder about next week’s Honor Roll breakfast.
        </div>

        <div class="mb-8 md:mb-16">
          Teachers get a unique phone number they can give to parents that isn’t a personal cell phone.
        </div>

        <div class="mb-8 md:mb-16">
          And, yes, we’ll translate your texts. Because all means <span class="text-cardstock-blue-500 underline">all</span>.
        </div>

        <div class="mb-8 md:mb-16">
          Parent deserve to hear how great their kids are. Every. Dang. Day.
        </div>

        <div class="mb-8 md:mb-16">
          Let's make parent communication a habit.
        </div>

        <div class="text-center">
          <a class="text-white py-2 px-4 rounded shadow-md cursor-pointer bg-cardstock-green-500 hover:bg-yes-green-500 outline-none font-bold" tabindex="0" href="mailto:lanny.bose@cardstockforteachers.com">
            Start Your Trial</a>
        </div>
      </div>
    </div>

  <div class="bg-gray-50" v-if="false">
    <div class="relative overflow-hidden">
      <div class="block absolute inset-y-0 h-full w-full">
        <div class="relative h-full">
          <svg class="absolute right-full transform translate-y-1/3 translate-x-1/4 md:translate-y-1/2 sm:translate-x-1/2 lg:translate-x-full" width="404" height="784" fill="none" viewBox="0 0 404 784">
            <defs>
              <pattern id="e229dbec-10e9-49ee-8ec3-0286ca089edf" x="0" y="0" width="20" height="20" patternUnits="userSpaceOnUse">
                <rect x="0" y="0" width="4" height="4" class="text-gray-200" fill="currentColor" />
              </pattern>
            </defs>
            <rect width="404" height="784" fill="url(#ad9a0a02-b58e-4a1d-8c36-1b649889af63)" />
          </svg>
          <svg class="absolute left-full transform -translate-y-3/4 -translate-x-1/4 sm:-translate-x-1/2 md:-translate-y-1/2 lg:-translate-x-3/4" width="404" height="784" fill="none" viewBox="0 0 404 784">
            <defs>
              <pattern id="d2a68204-c383-44b1-b99f-42ccff4e5365" x="0" y="0" width="20" height="20" patternUnits="userSpaceOnUse">
                <rect x="0" y="0" width="4" height="4" class="text-gray-200" fill="currentColor" />
              </pattern>
            </defs>
            <rect width="404" height="784" fill="url(#478e97d6-90df-4a89-8d63-30fdbb3c7e57)" />
          </svg>
        </div>
      </div>

      <div class="relative pt-6 pb-12 lg:pb-20">
        <div class="max-w-screen-xl mx-auto px-4 sm:px-6">
          <nav class="relative flex items-center justify-between sm:h-10 md:justify-center">
            <div class="flex items-center flex-1 md:absolute md:inset-y-0 md:left-0">
              <div class="flex items-center justify-between w-full md:w-auto">
                <a href="#" aria-label="Home">
                  <img class="h-8 w-auto sm:h-10" src="images/Cardstock_Logo_Wordmark_Color.svg" alt="Logo" />
                </a>
                <div class="-mr-2 flex items-center md:hidden">
                  <button type="button" class="inline-flex items-center justify-center p-2 rounded-md text-gray-400 hover:text-gray-500 hover:bg-gray-100 focus:outline-none focus:bg-gray-100 focus:text-gray-500 transition duration-150 ease-in-out" id="main-menu" aria-label="Main menu" aria-haspopup="true">
                    <svg class="h-6 w-6" stroke="currentColor" fill="none" viewBox="0 0 24 24">
                      <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M4 6h16M4 12h16M4 18h16" />
                    </svg>
                  </button>
                </div>
              </div>
            </div>
            <div class="hidden md:flex md:space-x-10" v-if="false">
              <a href="#" class="font-medium text-gray-500 hover:text-gray-900 transition duration-150 ease-in-out">Product</a>
              <a href="#" class="font-medium text-gray-500 hover:text-gray-900 transition duration-150 ease-in-out">Features</a>
              <a href="#" class="font-medium text-gray-500 hover:text-gray-900 transition duration-150 ease-in-out">Company</a>
            </div>
            <div class="hidden md:absolute md:flex md:items-center md:justify-end md:inset-y-0 md:right-0">
              <span class="inline-flex rounded-md shadow">
                <router-link :to="{name: 'login'}" class="inline-flex items-center px-4 py-2 border border-transparent text-base leading-6 font-medium rounded-md text-cardstock-blue-600 bg-white hover:text-cardstock-blue-500 focus:outline-none focus:border-cardstock-blue-300 focus:ring-cardstock-blue-500 active:bg-gray-50 active:text-cardstock-blue-700 transition duration-150 ease-in-out">
                  Log in
                </router-link>
              </span>
            </div>
          </nav>
        </div>

        <!--
          Mobile menu, show/hide based on menu open state.

          Entering: "duration-150 ease-out"
            From: "opacity-0 scale-95"
            To: "opacity-100 scale-100"
          Leaving: "duration-100 ease-in"
            From: "opacity-100 scale-100"
            To: "opacity-0 scale-95"
        -->
        <div class="absolute top-0 inset-x-0 p-2 transition transform origin-top-right md:hidden">
          <div class="rounded-lg shadow-md">
            <div class="rounded-lg bg-white ring-1 ring-black ring-opacity-5 overflow-hidden" role="menu" aria-orientation="vertical" aria-labelledby="main-menu">
              <div class="px-5 pt-4 flex items-center justify-between">
                <div>
                  <img class="h-8 w-auto sm:h-10" src="images/Cardstock_Logo_Wordmark_Color.svg" alt="Logo" />
                </div>
                <div class="-mr-2">
                  <button type="button" class="inline-flex items-center justify-center p-2 rounded-md text-gray-400 hover:text-gray-500 hover:bg-gray-100 focus:outline-none focus:bg-gray-100 focus:text-gray-500 transition duration-150 ease-in-out" aria-label="Close menu">
                    <svg class="h-6 w-6" stroke="currentColor" fill="none" viewBox="0 0 24 24">
                      <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M6 18L18 6M6 6l12 12" />
                    </svg>
                  </button>
                </div>
              </div>
              <div class="px-2 pt-2 pb-3">
                <a href="#" class="block px-3 py-2 rounded-md text-base font-medium text-gray-700 hover:text-gray-900 hover:bg-gray-50 focus:outline-none focus:text-gray-900 focus:bg-gray-50 transition duration-150 ease-in-out" role="menuitem">Product</a>
                <a href="#" class="mt-1 block px-3 py-2 rounded-md text-base font-medium text-gray-700 hover:text-gray-900 hover:bg-gray-50 focus:outline-none focus:text-gray-900 focus:bg-gray-50 transition duration-150 ease-in-out" role="menuitem">Features</a>
                <a href="#" class="mt-1 block px-3 py-2 rounded-md text-base font-medium text-gray-700 hover:text-gray-900 hover:bg-gray-50 focus:outline-none focus:text-gray-900 focus:bg-gray-50 transition duration-150 ease-in-out" role="menuitem">Company</a>
              </div>
              <div>
                <router-link :to="{name: 'login'}" class="block w-full px-5 py-3 text-center font-medium text-cardstock-blue-600 bg-gray-50 hover:bg-gray-100 hover:text-cardstock-blue-700 focus:outline-none focus:bg-gray-100 focus:text-cardstock-blue-700 transition duration-150 ease-in-out" role="menuitem">
                  Log in
                </router-link>
              </div>
            </div>
          </div>
        </div>

        <div class="mt-10 mx-auto max-w-screen-md px-4 sm:px-6 md:mt-16 lg:mt-20">
          <div class="text-center">
            <h2 class="text-4xl tracking-tight leading-10 font-extrabold text-gray-900 sm:text-5xl sm:leading-none md:text-6xl">
              Text. Call.
              <span class="text-cardstock-green-500">Translate.</span>
            </h2>
            <p class="mt-3 max-w-md mx-auto text-base text-gray-500 sm:text-lg md:mt-5 md:text-xl md:max-w-3xl">
              Cardstock is the tool for teachers and schools who want to keep parents in-the-loop and build strong relationships, <em>in every language</em>.
            </p>
          </div>
          <div class="mt-5 sm:mt-8 sm:flex sm:justify-center">
            <div class="rounded-md shadow">
              <a href="#" class="w-full flex items-center justify-center px-8 py-3 border border-transparent text-base leading-6 font-medium rounded-md text-white bg-cardstock-blue-500 hover:bg-cardstock-blue-400 focus:outline-none focus:border-cardstock-blue-600 focus:ring-cardstock-blue-500 transition duration-150 ease-in-out md:py-4 md:text-lg md:px-10">
                Start my 30 day trial
              </a>
            </div>
            <div class="mt-3 sm:mt-0 sm:ml-3">
              <a href="#" class="w-full flex items-center justify-center px-8 py-3 border border-transparent text-base leading-6 font-medium rounded-md text-cardstock-blue-500 bg-cardstock-blue-100 hover:text-cardstock-blue-600 hover:bg-cardstock-blue-50 focus:outline-none focus:ring-cardstock-blue-500 focus:border-cardstock-blue-300 transition duration-150 ease-in-out md:py-4 md:text-lg md:px-10">
                See how it works
              </a>
            </div>
          </div>

        </div>
      </div>
      <div class="relative">
        <div class="absolute inset-0 flex flex-col">
          <div class="flex-1"></div>
          <div class="flex-1 w-full bg-gray-800"></div>
        </div>
        <div class="max-w-screen-xl mx-auto px-4 sm:px-6">
          <img class="relative rounded-lg shadow-lg" src="https://tailwindui.com/img/component-images/top-nav-with-multi-column-layout-screenshot.png" alt="App screenshot">
        </div>
      </div>
    </div>
    <div class="bg-gray-800">
      <div class="max-w-screen-xl mx-auto pt-16 pb-20 px-4 sm:px-6 md:pb-24 lg:px-8">
        <h3 class="text-center text-gray-400 text-sm font-semibold uppercase tracking-wide">Trusted by school leaders at</h3>
        <div class="mt-8 grid grid-cols-2 gap-8 md:grid-cols-6 lg:grid-cols-5">
          <div class="col-span-1 flex justify-center md:col-span-2 lg:col-span-1">
            <img class="h-12" src="https://tailwindui.com/img/logos/tuple-logo.svg" alt="Tuple">
          </div>
          <div class="col-span-1 flex justify-center md:col-span-2 lg:col-span-1">
            <img class="h-12" src="https://tailwindui.com/img/logos/mirage-logo.svg" alt="Mirage">
          </div>
          <div class="col-span-1 flex justify-center md:col-span-2 lg:col-span-1">
            <img class="h-12" src="https://tailwindui.com/img/logos/statickit-logo.svg" alt="StaticKit">
          </div>
          <div class="col-span-1 flex justify-center md:col-span-3 lg:col-span-1">
            <img class="h-12" src="https://tailwindui.com/img/logos/transistor-logo.svg" alt="Transistor">
          </div>
          <div class="col-span-2 flex justify-center md:col-span-3 lg:col-span-1">
            <img class="h-12" src="https://tailwindui.com/img/logos/workcation-logo.svg" alt="Workcation">
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
</template>

<script>
import Toggle from '@/components/Toggle'
export default {
  components: {
    Toggle
  }
}
</script>
